import { createStyles } from '@mui/styles';
import { NextTheme } from '../../../layout/theme-next/provider';

export default (theme: NextTheme) =>
  createStyles({
    form: {
      minWidth: 400,
    },
    submitButton: {
      float: 'right',
      clear: 'right',
    },
    cancelButton: {
      float: 'right',
      marginRight: theme.spacing(1),
    },
  });
